export const DynamicFieldsApiUrl = '/platform/v1/accounts/dynamic-forms'

export const DynamicFieldsSections = {
  QUESTIONS: 'questions',
  DOCUMENTS: 'documents',
} as const

export const DynamicFieldsDefaultValue = {
  documents: [],
  questions: [],
}

export const DynamicQuestionCodes = {
  ACCEPTS_CASH_TRANSACTIONS: 'qAcceptsCashTransactions',
  ACTIONS_FOR_ASSESSMENTFAILURE: 'qActionsForAssessmentFailure',
  ADOPTS_RESPONSIBLE_GAMBLING_FRAMEWORK: 'qAdoptsResponsibleGamblingFramework',
  ALLOWS_PEER_TO_PEER_TRANSFERS: 'qAllowsPeerToPeerTransfers',
  ANY_EXPOSURE_TO_BVNK_PROHIBITED_JURISDICTIONS: 'qAnyExposureToBvnkProhibitedJurisdictions',
  APPROPRIATENESS_ASSESSMENT_PROCESS: 'qAppropriatenessAssessmentProcess',
  ASSESSMENT_FAILURE_RATE: 'qAssessmentFailureRate',
  ASSESSMENT_METHODS_AND_CRITERIA: 'qAssessmentMethodsAndCriteria',
  BLOCKCHAIN_MONITORING_TOOL: 'qBlockchainMonitoringTool',
  CFD_RISK_EDUCATION_METHODS: 'qCfdRiskEducationMethods',
  CLEAN_ASSETS_PURCHASE: 'qCleanAssetsPurchase',
  CLIENT_FUNDS_SECURITY_MEASURES: 'qClientFundsSecurityMeasures',
  CLIENT_TYPES: 'qClientTypes',
  COIN_ACCEPTANCE_POLICY: 'qCoinAcceptancePolicy',
  COMPANY_PRODUCT_DELIVERY_METHOD: 'qCompanyProductDeliveryMethod',
  COMPANY_PRODUCTS_OR_SERVICES: 'qCompanyProductsOrServices',
  COMPLIANCE_MATTER_CONTACT: 'qComplianceMatterContact',
  CONDUCTS_EDD_FOR_VIPS: 'qConductsEddForVips',
  CONDUCTS_EXISTING_CUSTOMER_KYC_REVIEWS: 'qConductsExistingCustomerKycReviews',
  DEPOSIT_AND_WITHDRAWAL_LIMITS: 'qDepositAndWithdrawalLimits',
  FACILITATE_CRYPTO_CURRENCY: 'qFacilitateCryptoCurrency',
  FACILITATE_UNLICENSED_CRYPTO_TOKENS: 'qFacilitateUnlicensedCryptoTokens',
  HAS_BEST_EXECUTION_POLICY: 'qHasBestExecutionPolicy',
  HAS_CLIENT_LOSS_CONTROLS: 'qHasClientLossControls',
  HAS_CODE_OF_CONDUCT_POLICY: 'qHasCodeOfConductPolicy',
  HAS_MINOR_ACCESS_CONTROLS: 'qHasMinorAccessControls',
  INDEPENDENT_MLRO: 'qIndependentMlro',
  IP_CAPTURE: 'qIpCapture',
  JURISDICTION_ACCESS_CONTROLS: 'qJurisdictionAccessControls',
  KYC_IMPLEMENTATION_STAGES: 'qKycImplementationStages',
  MAIN_MARKETS_COMPANY_TRADES_IN: 'qMainMarketsCompanyTradesIn',
  MAINTAINS_CLIENT_FUND_SEGREGATION: 'qMaintainsClientFundSegregation',
  MARKET_MANIPULATION_PREVENTION_MEASURES: 'qMarketManipulationPreventionMeasures',
  MARKETED_PRODUCTS_AND_SERVICES: 'qMarketedProductsAndServices',
  MLRO_EXPERIENCE_YEARS: 'qMlroExperienceYears',
  MONITORS_TRANSACTION_VELOCITY_AND_STRUCTURING: 'qMonitorsTransactionVelocityAndStructuring',
  NUMBER_OF_FTE_STUFF: 'qNumberOfFteStuff',
  OFFERS_INVESTMENT_ADVICE: 'qOffersInvestmentAdvice',
  PAST_REGULATORY_ACTIONS_OR_PENALTIES: 'qPastRegulatoryActionsOrPenalties',
  PERFORMS_COLD_CALLING: 'qPerformsColdCalling',
  PERIODIC_AML_ASSESSMENT: 'qPeriodicAmlAssessment',
  PERMITS_CROSS_BORDER_GAMBLING: 'qPermitsCrossBorderGambling',
  PREVENT_MARKET_MANIPULATION_OR_INSIDE_TRADING: 'qPreventMarketManipulationOrInsideTrading',
  PREVENTING_OPERATION_IN_LICENSE_REQUIRED_JURISDICTIONS:
    'qPreventingOperationInLicenseRequiredJurisdictions',
  PRIVACY_PROTOCOL_SUPPORT: 'qPrivacyProtocolSupport',
  PROBLEMATIC_GAMBLING_MONITORING_METHODS: 'qProblematicGamblingMonitoringMethods',
  PROVIDER_FOR_COMPLIANT_DATA_SHARING: 'qProviderForCompliantDataSharing',
  PROVIDES_SELF_EXCLUSION_TOOL: 'qProvidesSelfExclusionTool',
  REAL_TIME_MONITORING_FOR_SUSPICIOUS_TRANSACTIONS: 'qRealTimeMonitoringForSuspiciousTransactions',
  SANCTION_SCREENING_STAGE: 'qSanctionScreeningStage',
  SEGREGATION_OF_CLIENT_FUNDS: 'qSegregationOfClientFunds',
  SUPPORT_ICO: 'qSupportIco',
  TRAVEL_RULE_INFORCE: 'qTravelRuleInForce',
  TYPES_OF_CLIENTS_SERVICE_IS_OFFERED_TO: 'qTypesOfClientsServiceIsOfferedTo',
  UNDER_REGULATORY_INSPECTION: 'qUnderRegulatoryInspection',
  USES_CUSTODY_SOLUTIONS: 'qUsesCustodySolutions',
  UTILIZES_HOT_COLD_WALLETS: 'qUtilizesHotColdWallets',
  VPN_DETECTION_AND_MANAGEMENT: 'qVpnDetectionAndManagement',
  VULNERABLE_PLAYER_PROTECTION_MEASURES: 'qVulnerablePlayerProtectionMeasures',
  WALLET_DISTRIBUTION_AND_SECURITY_MEASURES: 'qWalletDistributionAndSecurityMeasures',
} as const
